import querystring from 'querystring';

export default function fetchQueryParams(searchParam = '?'): { [key: string]: any } {
  const searchParams = querystring.parse(searchParam.substring(1));
  const mappedParams: { [key: string]: any } = searchParams;

  Object.keys(searchParams).forEach((key) => {
    if (searchParams[key] === 'true' || searchParams[key] === 'false') {
      mappedParams[key] = searchParams[key] === 'true';
    }
  });

  return mappedParams;
}
